module.exports = __webpack_public_path__ + "img/Financeimg.536bbebf.png";